import { useQuery } from '@tanstack/react-query';


const fetchData = async (url) => {

  const res = await fetch(url);
  if (!res.ok) throw new Error(`Error fetching from ${url}`);
  const result = await res.json();
  console.log(result);

  return result;


};

export const useFetchData = (url, queryKeyName) => {
  return useQuery({
    queryKey: [queryKeyName, url], // unique cache key
    queryFn: () => fetchData(url),
    enabled: !!url, // only run if url is provided
  });
};

export const postRealEstateData = async (formData) => {
  const token = localStorage.getItem('token');
console.log("token is:", token);

  const response = await fetch('https://3dfinal.tanaghomtech.com/public/api/units', {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to post data');
  }

  return response.json();
};
export const postsup = async (formData) => {
  const token = localStorage.getItem('token');
  const response = await fetch('https://3dfinal.tanaghomtech.com/public/api/Subscriptions', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to post data');
  }

  return response.json();
};


export const postCarData = async (formData) => {
  const token = localStorage.getItem('token');
  const response = await fetch('https://3dfinal.tanaghomtech.com/public/api/cars', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to post data');
  }

  return response.json();
};
export const postDeveloperData = async (formData) => {
  const token = localStorage.getItem('token');
  const response = await fetch('https://3dfinal.tanaghomtech.com/public/api/developers', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to post data');
  }

  return response.json();
};
export const postDeveloperEdit = async (formData, id) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`https://3dfinal.tanaghomtech.com/public/api/developers/${id}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json', // هام جدًا
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  console.log("0", id);

  if (!response.ok) {
    throw new Error('Failed to post data');
  }

  return response.json();
};

//////////////////////////////////////////////////// profile /////////////////////////////////////////////////////////

export const updateImage = async (formData) => {
  const token = localStorage.getItem('token');
  const response = await fetch('https://3dfinal.tanaghomtech.com/public/api/updateProfileImage', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    method: 'POST',
    body: formData,

  });
  console.log("formData", formData);

  if (!response.ok) {
    throw new Error('Failed to post data');
  }

  const json = await response.json();
  console.log("Server response:", json);
  return json;
};
export const updateProfile = async (userData) => {
  const token = localStorage.getItem('token');
  const response = await fetch('https://3dfinal.tanaghomtech.com/public/api/updateProfile', {
    method: 'POST',

    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: userData,
  });

  if (!response.ok) {
    throw new Error('Failed to update profile');
  }

  return response.json();
};
///////////////////////////////////////////////////project//////////////////////////////////////////////////////////////////
export const projectData = async (formData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("No token found in localStorage");

   const response = await fetch("https://3dfinal.tanaghomtech.com/public/api/projects", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("❌ Backend error:", errorText);
    throw new Error(`Failed to post data: ${response.status}`);
  }

  return response.json();
};

export const postProjectEdit = async (formData, id) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`https://3dfinal.tanaghomtech.com/public/api/projects/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Accept': 'application/json',
    },
    method: 'POST',
    body: formData,
  });

  console.log("0", id);
  if (!response.ok) {
    throw new Error('Failed to post data');
  }

  return response.json();
};
export const projectmediaremove = async (id) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`https://3dfinal.tanaghomtech.com/public/api/projectmedia/${id}`, {
    method: 'Delete',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.json();
};